import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import { API_ROOT } from './config'

Vue.use(VueAxios, axios)

// global
export const getCitys = (config) => Vue.axios.get(API_ROOT + 'ac/cities', { params: config })
export const getDivisions = (config) => Vue.axios.get(API_ROOT + 'ac/divisions', { params: config })
export const getDoctors = (config) => Vue.axios.get(API_ROOT + 'ac/doctors', { params: config })
export const getProducts = (config) => Vue.axios.get(API_ROOT + 'ac/products', { params: config })
// user
export const getUserToken = (config) => Vue.axios.get(API_ROOT + 'users/current_user', { params: config })
export const postUser = (data) => Vue.axios.post(API_ROOT + 'users/sign_in', data)
export const deleteUser = (config) => Vue.axios.delete(API_ROOT + 'users/sign_out', { params: config })
// order
export const postOrder = (data, config) => Vue.axios.post(API_ROOT + 'orders', data, { params: config })
export const getPaymentPage = (token, config) => Vue.axios.get(API_ROOT + 'orders/' + token + '/payment', { params: config })



// WEBPACK FOOTER //
// ./src/api/index.js